import { Typography } from '@prenuvo/halo-web';

import { PagePanel } from '@/shared/ui';

export function NotFoundPage() {
  return (
    <PagePanel message="NOT_FOUND.SUB_TITLE" title="NOT_FOUND.TITLE" variant="warning">
      <Typography translationKey="NOT_FOUND.DESCRIPTION" variant="paragraph-md" />
    </PagePanel>
  );
}
